import React from 'react';
import outsourceImg from '../assets/NewHome/outsource.png';

const AboutWhiteOwl = () => {
  return (
    <section className=" py-32 pt-40 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12">
      <style>{`
        @keyframes gentleFloatY {
          0% { transform: translateY(-8px); }
          50% { transform: translateY(8px); }
          100% { transform: translateY(-8px); }
        }
        .about-owl-float {
          animation: gentleFloatY 8s ease-in-out infinite;
        }
      `}</style>
      <div className="max-w-7xl lg:max-w-[1200px] xl:max-w-[1300px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 md:gap-12 lg:gap-14 xl:gap-16">
          {/* Left Side - Graphic */}
          <div className="w-full lg:w-1/3 flex items-center justify-center about-owl-float">
            <img 
              src={outsourceImg} 
              alt="WhiteOwl Global Network" 
              className="w-1/2 sm:w-2/5 md:w-1/3 max-sm:w-[80%] lg:w-1/2 h-auto object-contain"
            />
          </div>

          {/* Right Side - Text Content */}
          <div className="w-full lg:w-[49%] flex flex-col gap-4 sm:gap-5 md:gap-6 lg:gap-7">
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 leading-relaxed" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
              <strong className="font-semibold text-gray-900">WhiteOwl</strong> is an AI-based SaaS platform dedicated to accelerating sales and business development for consulting firms using intelligent AI agents.
            </p>

            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 leading-relaxed" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
              We bring over a decade of B2B SaaS and digital transformation experience. Our journey began in 2011 with <strong className="font-semibold text-gray-900">Bizight Solutions</strong>, followed by our flagship SaaS product, <strong className="font-semibold text-gray-900">SalesPanda</strong> (2018), which now supports over 150,000 users in the Financial Services sector.
            </p>

            <p className="text-xs sm:text-sm md:text-base lg:text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
              Our platform was built through extensive market discovery by our founder, an ex-PwC consultant with 30 years of sales expertise. <strong className="font-semibold text-gray-900">WhiteOwl</strong> is brought to life by a dedicated team of young AI professionals focused on delivering streamlined sales solutions, allowing consultants to focus on their core tasks.
            </p>

            <p className="text-xs sm:text-sm md:text-base lg:text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
              We are committed to security and are an <strong className="font-semibold text-gray-900">ISO 27001-certified</strong> company.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutWhiteOwl;

